// @ts-nocheck
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";

const useIsAdmin = () => {
    return useAppSelector(state => state?.context?.session?.userRoles?.includes("Administrator"));
};

export default useIsAdmin;
